<template>
    <b-form-group class="b-form-group-flatpickr-custom">
        <b-input-group>
            <flat-pickr
                ref="REF_CALENDAR_MONTH"
                v-model="monthModel"
                class="form-control create-form-flatpicker border-right-0"
                :config="getDatePickConfig"
                placeholder="YYYY-MM"
                @input="handleSelectMonth"
            />
            <b-input-group-prepend
                is-text
                class="cursor-pointer"
                @click="openCalendar"
            >
                <SVGCalendarNumberIcon />
            </b-input-group-prepend>
        </b-input-group>

    </b-form-group>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
// import 'flatpickr/dist/flatpickr.css'
import MonthSelectPlugin from '@/libs/monthSelect'
import useDatepickConfig from '@/composables/useDatepickConfig'
import { getCurrentInstance, ref, computed, watch } from '@vue/composition-api'
import useSelectMonth from '@/composables/useSelectMonth'
import SVGCalendarNumberIcon from '@/assets/images/icons/calendar-with-number.svg'
export default {
    components: {
        flatPickr,
        SVGCalendarNumberIcon
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const REF_CALENDAR_MONTH = ref(null)

        const {
            monthModel,
            selectedMonth,
            monthOptions,
            handleSelectMonth
        } = useSelectMonth()
        const {
            datePickConfig,
            dateShortAndLonghand
        } = useDatepickConfig()
        const getDatePickConfig = computed(() => {
            const tmpConfig = {
                ...datePickConfig.value,
                locale: {
                    ...dateShortAndLonghand.value
                }
            }
            return tmpConfig
        })
        const openCalendar = () => {
            vm.$nextTick(() => {
                if (REF_CALENDAR_MONTH.value) {
                    REF_CALENDAR_MONTH.value.fp.open()
                }
            })
        }
        datePickConfig.value = {
            wrap: true,
            allowInput: false,
            minDate: monthOptions.value[monthOptions.value.length - 1],
            maxDate: monthOptions.value[0],
            plugins: [
                new MonthSelectPlugin({
                    shorthand: true,
                    dateFormat: 'Y-m'
                })
            ],
            disable: [
                function (date) {
                    const MM = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
                    return !monthOptions.value.includes(`${date.getFullYear()}-${MM}`)
                }
            ],
            onChange: [function (selectedArr, inputText, fp) {
                fp.config.buildMonths()
            }],
            onOpen: function (selectedArr, inputText, fp) {
                fp.config.buildMonths()
            }
        }
        watch(selectedMonth, (value, oldValue) => {
            monthModel.value = value
        })
        return {
            REF_CALENDAR_MONTH,
            datePickConfig,
            monthModel,
            selectedMonth,
            monthOptions,
            getDatePickConfig,
            openCalendar,
            handleSelectMonth
        }
    }
}
</script>
